import angular from 'angular';
import dropdown from './dropdown';

export default angular
  .module('commission.components.dropdown', [])
  .component('dropdown', dropdown).name;
